import React from "react"
import { types } from "react-bricks/frontend"
import Typography, { TypographyElement } from "../../../../react-bricks/Typography"

interface SuccessBoxProps {
    headline: TypographyElement[]
    text: TypographyElement[]
}

const SuccessBox: types.Brick<SuccessBoxProps> = () => {
    return (
        <div className="mb-5 rounded-base bg-white p-10 text-center sm:rounded-lg sm:px-20 sm:py-16 md:px-28 lg:px-[216px]">
            <div className="mx-auto mb-5 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-swamp-green text-white sm:mb-7 sm:h-15 sm:w-15 lg:mb-10 lg:h-[70px] lg:w-[70px]">
                <i className="lavita-icon text-lg sm:text-xl"></i>
            </div>
            <div className="flex flex-col gap-5 lg:gap-7">
                <Typography allowList={["h5"]} propName="headline" />
                <Typography allowList={["sup", "link"]} block="copytext-small" propName="text" />
            </div>
        </div>
    )
}

SuccessBox.schema = {
    name: "SuccessBox",
    label: "Success Box",
    hideFromAddMenu: true,
    getDefaultProps: (): SuccessBoxProps => ({
        headline: [
            {
                type: "h2",
                children: [
                    {
                        text: "Lorem ipsum",
                    },
                ],
            },
        ],
        text: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.",
                    },
                ],
            },
        ],
    }),
}

export default SuccessBox
